import TransactionsAllTransactionsReducer, {
  Actions as TransactionsAllTransactionsActions,
  initialState as initialTransactionsAllTransactionsState,
  TransactionsAllTransactionsState,
} from 'src/app/TransactionsAllTransactions/redux/transactionsAllTransactions.reducer'

export type TransactionsState = {
  transactionsAllTransactions: TransactionsAllTransactionsState
}

export const initialState: TransactionsState = {
  transactionsAllTransactions: initialTransactionsAllTransactionsState,
}

export type Actions = TransactionsAllTransactionsActions

const TransactionsReducer = (
  state = initialState,
  action: Actions,
): TransactionsState => ({
  transactionsAllTransactions: TransactionsAllTransactionsReducer(
    state.transactionsAllTransactions,
    action as TransactionsAllTransactionsActions,
  ),
})

export default TransactionsReducer
